/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IsoDayOfWeek,
    IsoDayOfWeekFromJSON,
    IsoDayOfWeekFromJSONTyped,
    IsoDayOfWeekToJSON,
    LocalDateLocalDateTuple,
    LocalDateLocalDateTupleFromJSON,
    LocalDateLocalDateTupleFromJSONTyped,
    LocalDateLocalDateTupleToJSON,
    LocalTimeLocalTimeTuple,
    LocalTimeLocalTimeTupleFromJSON,
    LocalTimeLocalTimeTupleFromJSONTyped,
    LocalTimeLocalTimeTupleToJSON,
} from './';

/**
 * 
 * @export
 * @interface TTLORuleDateTimeRestriction
 */
export interface TTLORuleDateTimeRestriction {
    /**
     * 
     * @type {Array<LocalDateLocalDateTuple>}
     * @memberof TTLORuleDateTimeRestriction
     */
    dateRanges?: Array<LocalDateLocalDateTuple> | null;
    /**
     * 
     * @type {Array<LocalTimeLocalTimeTuple>}
     * @memberof TTLORuleDateTimeRestriction
     */
    timeRanges?: Array<LocalTimeLocalTimeTuple> | null;
    /**
     * 
     * @type {Array<IsoDayOfWeek>}
     * @memberof TTLORuleDateTimeRestriction
     */
    weekDays?: Array<IsoDayOfWeek> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TTLORuleDateTimeRestriction
     */
    match?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TTLORuleDateTimeRestriction
     */
    comments?: string | null;
}

export function TTLORuleDateTimeRestrictionFromJSON(json: any): TTLORuleDateTimeRestriction {
    return TTLORuleDateTimeRestrictionFromJSONTyped(json, false);
}

export function TTLORuleDateTimeRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): TTLORuleDateTimeRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateRanges': !exists(json, 'dateRanges') ? undefined : (json['dateRanges'] === null ? null : (json['dateRanges'] as Array<any>).map(LocalDateLocalDateTupleFromJSON)),
        'timeRanges': !exists(json, 'timeRanges') ? undefined : (json['timeRanges'] === null ? null : (json['timeRanges'] as Array<any>).map(LocalTimeLocalTimeTupleFromJSON)),
        'weekDays': !exists(json, 'weekDays') ? undefined : (json['weekDays'] === null ? null : (json['weekDays'] as Array<any>).map(IsoDayOfWeekFromJSON)),
        'match': !exists(json, 'match') ? undefined : json['match'],
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
    };
}

export function TTLORuleDateTimeRestrictionToJSON(value?: TTLORuleDateTimeRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dateRanges': value.dateRanges === undefined ? undefined : (value.dateRanges === null ? null : (value.dateRanges as Array<any>).map(LocalDateLocalDateTupleToJSON)),
        'timeRanges': value.timeRanges === undefined ? undefined : (value.timeRanges === null ? null : (value.timeRanges as Array<any>).map(LocalTimeLocalTimeTupleToJSON)),
        'weekDays': value.weekDays === undefined ? undefined : (value.weekDays === null ? null : (value.weekDays as Array<any>).map(IsoDayOfWeekToJSON)),
        'match': value.match,
        'comments': value.comments,
    };
}


